import { ROUTES } from 'ts/Routes';
import * as React from 'react';
import { USERNAME } from 'ts/constants/UrlParams';
import { ErrorFlow } from 'ts/passwordless-login/components/pages/error/ErrorFlow';
import PageConfig from 'ts/services/userflow/PageConfig';
import { LogInNowSection } from 'ts/passwordless-login/components/pages/enter-username/sub-components/LoginSection';
import { AuthCard } from 'ts/components/Card';
import { EnterUsernameForm } from 'ts/passwordless-login/components/pages/enter-username/EnterUsernameForm';
import RegisterClipboard from 'images/register_clipboard.svg';
import { navigateToErrorPageFromRegister } from 'ts/passwordless-login/components/pages/error/ErrorNavigation';
import { History } from 'history';
import { Page } from 'ts/components/Page';
import { CaptchaDisclaimer } from 'ts/login/components/CaptchaDisclaimer';

interface RegisterEnterUsernamePageProps {
  history: History;
  location: Location;
}

const nextAction = (history: History) => (urlParams: string) => {
  history.push(`${ROUTES.REGISTER_ONE_TIME_CODE}?${urlParams}`);
};

const errorAction = (history: History) => (username: string) => {
  const urlParams = new URLSearchParams({
    [USERNAME]: username,
  } as any).toString();
  history.push({
    pathname: ROUTES.MANUAL_REG_FIND_CUSTOMER,
    search: `?${urlParams}`,
  });
};

const pageConfig = {
  errorType: ErrorFlow.register,
  startRoute: ROUTES.REGISTER_ENTER_USERNAME,
  analytics: { pageName: 'register', taskName: 'my-account-registration' },
} as PageConfig;

const RegisterEnterUsernamePage: React.FC<RegisterEnterUsernamePageProps> = ({
  history,
  location,
}) => {
  return (
    <Page>
      <AuthCard image={RegisterClipboard}>
        <>
          <EnterUsernameForm
            history={history}
            location={location}
            nextAction={nextAction(history)}
            config={pageConfig}
            customErrorAction={errorAction(history)}
            navigateToErrorPage={navigateToErrorPageFromRegister(history)}
            infoText="Please enter the email address or mobile number you provided when signing up for your Origin Energy account."
          />
          <LogInNowSection />
          <CaptchaDisclaimer />
        </>
      </AuthCard>
    </Page>
  );
};

export { RegisterEnterUsernamePage };
